var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._v(" Just Flags. "),_c('flag',{attrs:{"iso":"de"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }